import React from 'react'

import Decklist from 'components/decklists/DeckListWithMetaData'

export const JanuaryDeck: React.FC = () => {
  return (
    <Decklist
      name="Vertex 0-3 Deck"
      drafter="Parker LaMascus"
      description={
        <>
          Game plan: lock &rsquo;em out with Solitary Confinement, or mill
          myself for Lab Man. Execution of the plan: Howling Mine and Magus
          really helped my opponents beat me.
        </>
      }
      maindeck={[
        [
          { name: 'Ghost Quarter', set: 'DIS' },
          { name: 'Frontier Bivouac', set: 'KTK' },
          { name: 'Mountain', set: 'TSP' },
          { name: 'Mountain', set: 'TSP' },
          { name: 'Seaside Citadel', set: 'ALA' },
          { name: 'Grove of the Burnwillows', set: 'FUT' },
          { name: 'Temple of Abandon', set: 'THS' },
          { name: 'Adarkar Wastes', set: '10E' },
          { name: 'Pinecrest Ridge', set: 'CHK' },
          { name: 'Terramorphic Expanse' },
          { name: 'Temple of Epiphany', set: 'JOU' },
          { name: 'Yavimaya Coast', set: '10E' },
          { name: 'Dreamroot Cascade', set: 'VOW' },
          { name: 'Temple of Triumph', set: 'THS' },
          { name: 'Forbidden Orchard', set: 'C16' },
          { name: 'Gnottvold Slumbermound', set: 'KHM' },
          { name: 'Forest', set: 'M11' },
        ],
        [
          { name: 'Birds of Paradise', set: 'RAV' },
          { name: 'Magus of the Vineyard', set: 'FUT' },
          { name: 'Flame Jab', set: 'EVE' },
          { name: 'Ancestral Vision', set: 'TSP' },
          { name: 'Lotus Bloom', set: 'TSR' },
        ],
        [
          { name: 'Riftsweeper', set: 'FUT' },
          { name: 'Burning-Tree Emissary', set: 'GTC' },
          { name: 'Punishing Fire', set: 'ZEN' },
          { name: "Memory's Journey", set: 'ISD' },
          { name: 'Wear Away', set: 'CHK' },
          { name: 'Life From the Loam', set: 'RAV' },
          { name: 'Howling Mine', set: 'C16' },
        ],
        [
          { name: 'Laboratory Maniac', set: 'ISD' },
          { name: 'Trygon Predator', set: 'DIS' },
          { name: 'Squee, Goblin Nabob', set: 'MMA' },
          { name: 'Solitary Confinement', set: 'MH2' },
          { name: 'Reality Acid', set: 'PLC' },
          { name: 'As Foretold', set: 'AKH' },
        ],
        [{ name: 'Tolarian Sentinel', set: 'TSR' }],
        [
          { name: 'Damia, Sage of Stone', set: 'CMD' },
          { name: 'Garza Zol, Plague Queen', set: 'CSP' },
          { name: 'Blasphemous Act', set: 'ISD' },
        ],
      ]}
    />
  )
}
